const ORG_HASH_KEY = "sd-feature-flags-orghash";

export const sha256Hex = async (input: string): Promise<string> => {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

export const readCachedOrgHash = (orgId: string): string | null => {
  try {
    const raw = localStorage.getItem(ORG_HASH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { orgId?: string; hash?: string };
    return parsed.orgId === orgId && typeof parsed.hash === "string"
      ? parsed.hash
      : null;
  } catch {
    return null;
  }
};

export const cacheOrgHash = (orgId: string, hash: string): void => {
  try {
    localStorage.setItem(ORG_HASH_KEY, JSON.stringify({ orgId, hash }));
  } catch {
    // best-effort; ignore quota / private-mode errors
  }
};
